import React from "react";
import "../../App.css";
import CompilerError from "../CompilerError";
import Problem from "../Problem";
import Suggestion from "../Suggestion";
import BadExample from "../BadExample";
import GoodExample from "../GoodExample";
import { makeClassStubIfUnknown } from "../../demoValues";

class IncorrectDimensionExpression1 extends React.Component {

  render() {
    const classPlaceholder = <div className="Indent-0">{makeClassStubIfUnknown(this.props.typeName)}</div>;

    return <CompilerError
      title="Variable must provide either dimension expressions or an array initializer"
      translation="You have not given the array a certain size."
      embed={this.props.embed} 
      fontSize={this.props.fontSize}
    >
      <Problem
        title="You may have forgotten to type the size of the array inside the brackets."
      >
        <Suggestion title="Specify the size of the array.">
          <BadExample>
            {classPlaceholder}
            <div className="Indent-0">{this.props.typeName}[] {this.props.arrName} = new {this.props.typeName}[];</div>
          </BadExample>

          <GoodExample>
            {classPlaceholder}
            <div className="Indent-0">{this.props.typeName}[] {this.props.arrName} = new {this.props.typeName}[5];</div>
          </GoodExample>
        </Suggestion>
      </Problem>
    </CompilerError>;
  }
}

export default IncorrectDimensionExpression1;
